import axios from 'axios';

const request = (options, onSuccess, onError) => {
  const { headers, ...restOptions } = options;
 
  const axiosInstance = {
    headers: {
      'X-EKINCARE-KEY': sessionStorage.getItem('axiosHeaders'),
      'X-COMPANY-ID':  sessionStorage.getItem('company_id'),
      ...headers,
    },
    baseURL: window.API_URL,
  };

  const client = axios.create(axiosInstance);

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }
      const { status } = error.response;
      
      if (status === 401) {
        window.location.href = '/login';
      } else if (status === 403) {
        window.location.href = '/forbidden';
      }
      
      return Promise.reject(error);
    }
  )

  options = {
    ...restOptions,
  };
  const requestPromise = client(options);
  if (onSuccess) {
    /*
      returns promise itself instead of resolving here
      if onsuccess is not passed as argument.
    */
    return requestPromise.then(onSuccess).catch((error, ...rest) => {
      onError(error, ...rest);
    });
  }
  return requestPromise;
};

export default request;
